import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getMyUserGroupAll = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getmyusergroupall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getmyusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const changeBusinessUser = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/changebusinessuser/' + params.id + '/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getTeamReport = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getteamreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const uploadAddFile = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/uploadaddfile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const cancel = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/cancel/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const callBack = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/callback' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const distribution = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/distribution' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const addToRemark = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/addtoremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const reschedule = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/reschedule' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const uploadMaintainPicture = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/uploadmaintainpicture/' + params.id + '' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const removeMaintainPicture = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/removemaintainpicture/' + params.maintainPictureId + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getMyBusinessPage = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getmybusinesspage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMaintainGroupTeamReport = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getmaintaingroupteamreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyMaintainPage = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getmymaintainpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyMaintainDeviceRecord = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/modifymaintaindevicerecord' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const removeMaintainDeviceRecord = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/removemaintaindevicerecord/' + params.maintainDeviceRecordId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changeMaintainer = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/changemaintainer/' + params.id + '/' + params.maintainerId + '/' + params.maintainerlsit + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getMyGroupNotMaintainNum = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getmygroupnotmaintainnum' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const confirmMaintained = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/confirmmaintained' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getCanMakeRecordDevices = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getcanmakerecorddevices/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyNotMaintainNum = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getmynotinstallnum' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyMaintainGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/getmymaintaingrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addMaintainDeviceRecord = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/addmaintaindevicerecord' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const forceConfirmMaintained = (params, urlParams) => {
  return axios.request({
    url: '/om/maintainorder/forceconfirmmaintained' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

